import { render, staticRenderFns } from "./address_fields.vue?vue&type=template&id=fe13533a&"
import script from "./address_fields.vue?vue&type=script&lang=js&"
export * from "./address_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports